const shouldForwardPropEmotion = (clearAttrs) => {
  return {
    shouldForwardProp: (prop) => !clearAttrs.includes(prop),
  };
};

export default shouldForwardPropEmotion;
